<script>
import { BModal } from 'bootstrap-vue';
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';
import { Alert } from '../../services/alert';

export default {
  components: {
    BModal,
    VuePdfEmbed,
  },

  data () {
    return {
      file: null,
      iconComponentsMap: {
        'pdf': 'IconTextFile',
        'jpg': 'IconImageFile',
        'jpeg': 'IconImageFile',
        'png': 'IconImageFile',
        'jpeg': 'IconImageFile',
        'mp3': 'IconSoundFile',
        'mp4': 'IconVideoFile',
        'webm': 'IconVideoFile',
        'ogg': 'IconVideoFile',
      },
      isLoading: true,
      error: false,
    };
  },

  mounted () {
    Bus.$on('openFileModal', (file) => {
      this.isLoading = true;
      this.error = false;
      this.file = file;

      this.openModal();
    });
  },

  computed: {
    completeFileName () {
      if (!this.file) {
        return 'Arquivo não selecionado';
      }

      return `${this.file.title}.${this.file.extension}`;
    },

    isImage () {
      if (!this.file || !this.file.extension) {
        return false;
      }

      const imageFileExtensions = ['jpg', 'jpeg', 'png', 'webp'];

      return imageFileExtensions.includes(this.file.extension);
    },

    isVideo () {
      if (!this.file || !this.file.extension) {
        return false;
      }

      const videoFileExtensions = ['mp4', 'webm', 'ogg'];

      return videoFileExtensions.includes(this.file.extension);
    },

    isPdf () {
      if (!this.file || !this.file.extension) {
        return false;
      }

      return this.file.extension === 'pdf';
    },

    iconComponentName () {
      const componentName = this.iconComponentsMap[this.file.extension];

      if (!componentName) {
        return 'IconFile';
      }

      return componentName;
    },

    isFileVisualizable () {
      if (!this.file || !this.file.extension) {
        return false;
      }

      const visualizableFileExtensions = ['pdf', 'jpg', 'jpeg', 'webp', 'png', 'mp4', 'webm', 'ogg'];

      return visualizableFileExtensions.includes(this.file.extension);
    },
  },

  methods: {
    openModal () {
      this.$refs['lead-file-modal'].show();
    },

    hideModal () {
      this.$refs['lead-file-modal'].hide();
    },

    handleError () {
      Alert.error(this.__('Falha ao carregar arquivo'));

      this.isLoading = false;
      this.error = true;
    },
  },
};
</script>

<template>
  <BModal
    id="lead-file-modal"
    ref="lead-file-modal"
    centered
  >
    <template slot="modal-header">
      <h2 class="modal-title">
        {{ completeFileName ? completeFileName : __('Arquivo sem nome') }}
      </h2>

      <button
      class="close"
      type="button"
      data-dismiss="modal"
      aria-label="Close"
      @click="hideModal()"
    >
      <span aria-hidden="true" ><img
        class="mb-1"
        src="/build/icons/close@white.svg"
        alt="Fechar"
        width="14"
        height="13"
      ></span>
    </button>
    </template>
    <template slot="default">
      <div
        v-if="file && isFileVisualizable && !error"
        class="modal-content-container w-100"
        :class="{ 'is-pdf': (isPdf && !isLoading) }"
      >
        <img
          v-if="isImage"
          v-show="!isLoading"
          :src="file.signedUrl"
          @load="isLoading = false"
          @error="handleError"
        >
        <video
          v-else-if="isVideo"
          v-show="!isLoading"
          controls
          :src="file.signedUrl"
          @canplay="isLoading = false"
          @error="handleError"
        >
        </video>
        <!-- <embed
          v-else-if="isPdf"
          :src="file.url + '#toolbar=0&navpanes=0&scrollbar=0&view=FitH'"
          :class="{ 'is-loading': isLoading }"
          type="application/pdf"
          @load="isLoading = false"
          @error="handleError"
        /> -->
        <VuePdfEmbed
          v-else-if="isPdf"
          :width="666"
          :source="file.signedUrl"
          :class="{ 'is-loading': isLoading }"
          type="application/pdf"
          @loaded="isLoading = false"
          @loading-failed="handleError"
          @rendering-failed="handleError"
          @printing-failed="handleError"
        />
        <div v-show="isLoading" class="loader-container">
          <i class="fa fa-circle-o-notch fa-spin" />
        </div>
      </div>
      <div
        v-else-if="file || (file && error)"
        class="file-component-container d-flex flex-column align-items-center justify-content-center"
      >
        <Component :is="iconComponentName" color="#71767D" :size="48"/>
        <p class="file-name mt-2">{{ completeFileName }}</p>
      </div>
    </template>
    <template slot="modal-footer">
      <div class="py-4">
        <a
          :href="file ? `/file/${file.id}/download` : ''"
          class="salesflow-btn salesflow-btn-secondary"
          download
        >
          {{ __('Baixar') }}
        </a>
      </div>
    </template>
  </BModal>
</template>

<style lang="scss">
  @import '../../../sass/variables';
  @import '../../../sass/mixins';

  #lead-file-modal {
    .modal-dialog {
      min-width: 716px;
    }

    .modal-content {
      border-radius: 16px;
      overflow: hidden;
    }

    .modal-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px 24px;

      .modal-title {
        @include salesflow-text($font-weight: 600, $color: white);
        text-transform: none;
      }
    }

    .modal-body {
      padding: 0px;
      max-height: 62vh;
      overflow-y: scroll;

      &::-webkit-scrollbar {
        display: none;
      }

      .loader-container {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .modal-content-container {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0px;
        min-height: 23.5rem;
        overflow-y: scroll;
        background-color: $salesflow-bg-content;

        &::-webkit-scrollbar {
          display: none;
        }

        &.is-pdf {
          padding: 16px 24px;
          height: 62vh;
          overflow-y: scroll;

          .vue-pdf-embed {
            max-height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 16px;

            & > div:last-child {
              padding-bottom: 16px;
            }
          }
        }

        img, video {
          max-width: 714px;
        }

        .file-name {
          @include salesflow-subtitle($font-weight: 500, $color: $salesflow-font-gray);
        }
      }

      .file-component-container {
        min-height: 23.5rem;
        background-color: $salesflow-bg-content;
      }
    }

    .modal-footer {
      padding: 0px 24px;
      background-color: $salesflow-bg-content;

      div {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-top: 1px solid $salesflow-outline-gray-medium;

        a {
          text-decoration: none;

          &:hover {
            color: white;
          }
        }
      }
    }
  }
</style>
